<template>
  <div class="doughnut-chart-container">
    <canvas ref="doughnutChart"></canvas>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import ChartJS from 'chart.js'

export default {
  name: 'DoughnutChart',
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        cutout: '70%',
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              padding: 25
            }
          }
        }
      })
    }
  },
  methods: {
    renderCustomChart(data, options) {
      const ctx = this.$refs.doughnutChart.getContext('2d')
      if (ctx) {
        new ChartJS(ctx, {
          type: 'doughnut',
          data: data,
          options: options
        })
      } else {
        if (process.env.NODE_ENV !== 'test') {
          console.error('Canvas context is not available')
        }
      }
    }
  },
  mounted() {
    this.renderCustomChart(this.chartData, this.chartOptions)
  },
  watch: {
    chartData: function () {
      this.renderCustomChart(this.chartData, this.chartOptions)
    }
  }
}
</script>
<style lang="css" scoped>
.doughnut-chart-container {
  width: 400px;
  height: 200px;
  position: relative;
}

.doughnut-chart-container canvas {
  width: 100%;
}
</style>
